export const SHOW = 'backdrop/SHOW'
export const HIDE = 'backdrop/HIDE'

// quiet: 화면은 막되(눌리지 않게) 아무것도 보여주지 않는다
const initState = {
    show: false,
    background: '',
    msg: '',
    quiet: false
}

const background = {
    dark: 'rgba(0, 0, 0, .92)'
}

export default (state = initState, action) => {
    switch(action.type) {
        case SHOW:
            return {
                show: true,
                background: action.background ? background[action.background] : '',
                msg: action.msg,
                quiet: Boolean(action.quiet)
            }
        case HIDE:
            return initState
        default:
            return initState
    }
}